import _forEach from 'lodash/forEach';
import _remove from 'lodash/remove';
import _filter from 'lodash/filter';
import _difference from 'lodash/difference';

export default class ManageStudentsController {
  /** @ngInject */
  constructor(
    $log, $scope, $mdDialog, $mdToast, $timeout,
    TagService,
    StudentService,
    students,
    tag,
    groups,
    schoolClasses
  ) {
    this.$log = $log;
    this.$scope = $scope;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$timeout = $timeout;
    this.StudentService = StudentService;
    this.TagService = TagService;
    this.students = students.data.students;
    this.tag = {};
    angular.copy(tag, this.tag);
    this.groups = groups;
    this.schoolClasses = schoolClasses;
    this.selectedGroupId = 0;
    this.selectedSchoolClass = null;

    this.students = this.students.map(student => {
      student.id = Number(student.id);
      student.name = student.fullName;
      return student;
    });

    this.selectedStudents = this.tag.data.students || [];
    this.taggedStudents = [];
    _forEach(this.selectedStudents, student => {
      const removedStudent = _remove(this.students, n => student.id === n.id);
      if (removedStudent.length > 0) {
        this.taggedStudents.push(removedStudent[0]);
      }
    });
    this.allStudents = Object.assign([], this.students);
    this.copyStudents = Object.assign([], this.students);
    this.filter();

    this.treeOptions = {
      removed: node => {
        this.$timeout(() => {
          _remove(this.copyStudents, n => node.item.id === n.id);
        }, 0);
      }
    };

    this.treeOptions2 = {
      dropped: () => {
        this.$timeout(() => this.filter(), 0);
      }
    };
  }

  find(item) {
    return !(this.query && this.query.length > 0 && item.name.indexOf(this.query) === -1);
  }

  filter() {
    const diff = _difference(this.allStudents, this.copyStudents);
    if (diff.length > 0) {
      _forEach(diff, item => {
        this.copyStudents.push(item);
      });
    }

    if (this.selectedGroupId && !this.selectedSchoolClass) {
      this.allStudents = _filter(this.copyStudents, {groupId: this.selectedGroupId});
      return;
    }

    if (!this.selectedGroupId && this.selectedSchoolClass) {
      this.allStudents = _filter(this.copyStudents, {schoolClassName: this.selectedSchoolClass});
      return;
    }

    if (this.selectedGroupId && this.selectedSchoolClass) {
      this.allStudents = _filter(this.copyStudents, {groupId: this.selectedGroupId, schoolClassName: this.selectedSchoolClass});
      return;
    }

    this.allStudents = this.copyStudents;
  }

  save() {
    this.$mdDialog.hide(this.taggedStudents);
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
